export default "__VITE_ASSET__279a556c__"